import { serialize } from 'utils/utils';
import { TYPES as PANDA_TYPES } from 'actions/pandaActions';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  CALENDAR_OFFERS_REQUEST: 'CALENDAR_OFFERS_REQUEST',
  CALENDAR_OFFERS_SUCCESS: 'CALENDAR_OFFERS_SUCCESS',
  CALENDAR_OFFERS_FAILURE: 'CALENDAR_OFFERS_FAILURE',
};

export const loadCalendarOffers = (config) => {
  const defaultParams = {
    calDateFlexibility: 0,
    calDate: 0,
    state: 'MANDATORY-TO-BE-OVERRIDEN',
    url: 'MANDATORY-TO-BE-OVERRIDEN',
    page: 1,
    results: 1000,
    augmentAccom: 'false',
    minPriceByNights: 'true',
  };

  const params = Object.assign(defaultParams, config);

  return {
    [CALL_API]: {
      types: [TYPES.CALENDAR_OFFERS_REQUEST, TYPES.CALENDAR_OFFERS_SUCCESS, TYPES.CALENDAR_OFFERS_FAILURE],
      schema: Schemas.CALENDAR_OFFERS,
      endpoint: `/api/pandaOffers.json?${serialize(params)}`,
    },
  };
};

export const calDateChanged = () => ({
  type: PANDA_TYPES.CAL_DATE_CHANGED,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/calendarOfferActions.js
 **/